import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../helpers/common'
import { register } from '../../../helpers/reducerRegistry'
import {
  getHighlight,
  getOverdueSocialInsurance,
  getOverdueTaxDebt,
} from './thunk'

const initialState = {
  highlight: {},
  overdueTaxDebt: {
    overdueTaxDebtHistory: [],
    invoiceEnforcementHistory: [],
  },
  overdueSocialInsurance: {},
  overdueSocialInsuranceIds: [],

  loading: {
    highlight: true,
    overdueTaxDebt: true,
    overdueSocialInsurance: true,
  },
}

export const slice = createSlice({
  name: 'companyAnalysis/filingStatus',
  initialState,
  reducers: {
    resetStore: () => initialState,
  },
  extraReducers: (builder) => {
    //getHighlight
    builder.addCase(getHighlight.pending, (state) => {
      state.loading.highlight = true
    })
    builder.addCase(getHighlight.fulfilled, (state, action) => {
      state.highlight = action.payload
      state.loading.highlight = false
    })
    builder.addCase(getHighlight.rejected, (state, action) => {
      state.loading.highlight = action.payload.loading
    })
    //getOverdueTaxDebt
    builder.addCase(getOverdueTaxDebt.pending, (state) => {
      state.loading.overdueTaxDebt = true
    })
    builder.addCase(getOverdueTaxDebt.fulfilled, (state, action) => {
      state.overdueTaxDebt = action.payload
      state.loading.overdueTaxDebt = false
    })
    builder.addCase(getOverdueTaxDebt.rejected, (state, action) => {
      state.loading.overdueTaxDebt = action.payload.loading
    })
    //getOverdueSocialInsurance
    builder.addCase(getOverdueSocialInsurance.pending, (state) => {
      state.loading.overdueSocialInsurance = true
    })
    builder.addCase(getOverdueSocialInsurance.fulfilled, (state, action) => {
      const data = action.payload.map((i, index) => ({ id: index, ...i }))
      state.overdueSocialInsuranceIds = data.map((i, index) => index)
      state.overdueSocialInsurance = keyBy([...data], 'id')
      state.loading.overdueSocialInsurance = false
    })
    builder.addCase(getOverdueSocialInsurance.rejected, (state, action) => {
      state.loading.overdueSocialInsurance = action.payload.loading
    })
  },
})

export const selectHighlight = (callback) => (state) => {
  const data = state[slice.name].highlight
  return callback ? callback(data) : data
}

export const selectOverdueTaxDebt = (callback) => (state) => {
  const data = state[slice.name].overdueTaxDebt
  return callback ? callback(data) : data
}
export const selectOverdueTaxDebtHistory = (id, attr) => (state) => {
  const data = state[slice.name].overdueTaxDebt?.overdueTaxDebtHistory.find(
    (item) => item.publicDateId === id,
  )
  return attr ? data[attr] : data
}
export const selectInvoiceEnforcementHistory = (id, attr) => (state) => {
  const data = state[slice.name].overdueTaxDebt?.invoiceEnforcementHistory.find(
    (item) => item.publicDateId === id,
  )
  return attr ? data[attr] : data
}

export const selectOverdueSocialInsuranceIds = (callback) => (state) => {
  const data = state[slice.name].overdueSocialInsuranceIds
  return callback ? callback(data) : data
}
export const selectOverdueSocialInsurance = (id, attr) => (state) => {
  const data = state[slice.name].overdueSocialInsurance
  return attr ? data[id][attr] : data[id]
}

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return state[slice.name].loading[type]
}

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
